import { render, staticRenderFns } from "./Configration.vue?vue&type=template&id=8a04fffa&scoped=true&"
import script from "./Configration.vue?vue&type=script&lang=js&"
export * from "./Configration.vue?vue&type=script&lang=js&"
import style0 from "./Configration.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Configration.vue?vue&type=style&index=1&id=8a04fffa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a04fffa",
  null
  
)

export default component.exports